export const REDUX_SAVE_LOGIN_INFO = 'REDUX_SAVE_LOGIN_INFO'
export const REDUX_DESTROY_SESSION = 'REDUX_DESTROY_SESSION'
export const REDUX_SET_MUST_CREATE_PASSWORD = 'REDUX_SET_MUST_CREATE_PASSWORD'
export const REDUX_SET_ACCESS_TOKEN = 'REDUX_SET_ACCESS_TOKEN'
